import { Box, Grid, Stack, useMediaQuery, useTheme } from "@mui/material";

import CardItem from "./card-item-map";
import PathDrawing from "./pathDrawing";

function DestinationArrivalCard({
  origin,
  destination,
  contrast = "dark",
}: {
  origin: string;
  destination: string;
  contrast?: "dark" | "light";
}) {
  const theme = useTheme();

  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Grid
      container
      direction="row"
      // spacing={2}
      sx={{
        width: "100%",
        margin: 0,
        flexWrap: "wrap",
      }}
    >
      {/* Departure */}
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <CardItem label="Départ" content={origin} contrast={contrast} />
      </Grid>

      {/* Journey Visualization */}
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            minHeight: { xs: 80, md: "auto" },
            width: "100%",
          }}
        >
          <Stack
            direction={isMdUp || isSmUp ? "row" : "column"}
            spacing={1}
            alignItems="center"
            sx={isMdUp || isSmUp ? { width: "100%" } : { py: 2, width: "100%" }}
          >
            <Box sx={{ flex: 1, position: "relative" }}>
              <PathDrawing />
            </Box>
          </Stack>
        </Box>
      </Grid>

      {/* Arrival */}
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <CardItem label="Arrivée" content={destination} contrast={contrast} />
      </Grid>
    </Grid>
  );
}

export default DestinationArrivalCard;
